import Axios from 'axios';

import { ApplicationConfig, ReloadableConfig, RootConfig } from '../../../types/config.types';

// eslint-disable-next-line unicorn/no-static-only-class
export class ReactConfigLoader {
  static loadApplicationConfig = async (): Promise<ApplicationConfig> =>
    Axios.get<ApplicationConfig>(`${process.env.PUBLIC_URL}/configurations/application.json`).then(
      (result) => result.data
    );

  static loadReloadableConfig = async (): Promise<ReloadableConfig> =>
    Axios.get<ReloadableConfig>(`${process.env.PUBLIC_URL}/configurations/reloadable.json`).then(
      (result) => result.data
    );

  static mergeConfigs = (
    applicationConfig: ApplicationConfig,
    reloadableConfig: ReloadableConfig
  ): RootConfig => ({
    ...applicationConfig,
    toggles: {
      ...reloadableConfig,
    },
  });

  static init = async (): Promise<RootConfig> => {
    const applicationConfig = await this.loadApplicationConfig();
    const reloadableConfig = await this.loadReloadableConfig();

    return this.mergeConfigs(applicationConfig, reloadableConfig);
  };
}
